/**
 * @desc directive that compares the integer values of two inputs, checks if one is lower than the other, and sets the form validity respectively
 */

(function() {
	'use strict';

	angular
		.module('directives')
		.directive('compareWith', compareWith);

	function compareWith() {
		var directive = {
			require: 'ngModel',
			link: link
		};
		return directive;

		function link($scope, $element, $attrs, ctrl) {
			var validate = function(viewValue) {
				var comparisonModel = $attrs.compareWith;

				if(!viewValue || !comparisonModel){
					// It's valid because there is no comparison
					ctrl.$setValidity('compareWith', true);
					return viewValue;
				}

				if (typeof $attrs.validComparison !== undefined) {
					if ($attrs.validComparison == 'false') {
						ctrl.$setValidity('compareWith', true);
						return viewValue;
					}
				}

				if($attrs.operator === 'lower') {
					// It's valid if viewValue is lower than the comparison
					ctrl.$setValidity('compareWith', parseInt(viewValue, 10) < parseInt(comparisonModel, 10) );
				}
				if($attrs.operator === 'greater') {
					// It's valid if viewValue is higher than the comparison
					ctrl.$setValidity('compareWith', parseInt(viewValue, 10) > parseInt(comparisonModel, 10) );
				}
				return viewValue;
			};

			ctrl.$parsers.unshift(validate);
			ctrl.$formatters.push(validate);

			$attrs.$observe('compareWith', function(comparisonModel){
				return validate(ctrl.$viewValue);
			});
		}
	}
})();
